import axios from 'axios'
import { BASE_URL, isPortalRequest } from '@/environment/environment'

/**
 * Сервис нажатия action-кнопок в уведомлениях.
 * По договорённости с бекендом фронт не различает конкретные пути (responsibility complete,
 * take-in-progress и пр.) — бек кладёт готовый url прямо в объект кнопки уведомления.
 * Фронт делает POST на этот url с телом из поля payload той же кнопки.
 */
export const notificationButtonApi = {
  /**
   * POST по url из объекта кнопки с её payload.
   * Если бек прислал относительный путь (начинающийся с `/`), добавляем BASE_URL префикс.
   * Абсолютный адрес принимаем только если это тот же origin, что у API портала.
   */
  invokeButton(url: string, payload: Record<string, unknown>) {
    const fullUrl = url.startsWith('http') ? url : `${BASE_URL}${url}`
    if (!isPortalRequest(fullUrl)) {
      return Promise.reject(new Error('Адрес действия уведомления не относится к API портала'))
    }

    return axios.post(fullUrl, { payload })
  },
}
